<template>
    <div class="language-switcher">
      <select v-model="currentLocale" @change="changeLocale" class="language-select">
        <option value="en_us">English</option>
        <option value="sv">Svenska</option>
      </select>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  
  export default defineComponent({
    name: 'LanguageSwitcher',
    setup() {
      const { locale } = useI18n();
      const currentLocale = ref(locale.value);
  
      const changeLocale = () => {
        // Update the locale in i18n
        locale.value = currentLocale.value;
        
        // Save to localStorage for persistence
        localStorage.setItem('userLocale', currentLocale.value);
      };
  
      return {
        currentLocale,
        changeLocale
      };
    }
  });
  </script>
  
  <style scoped>
  .language-switcher {
    width: 100%;
  }
  
  .language-select {
    width: 100%;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    background-color: white;
    color: #1f2937;
    font-size: 15px;
    transition: all 0.2s ease;
    cursor: pointer;
    outline: none;
  }
  
  .language-select:focus {
    border-color: theme('colors.primary.dark');
    box-shadow: 0 0 0 2px rgba(123, 31, 162, 0.2);
  }
  </style>